// functions
function headerScrolling() {
	if(window.scrollY > 5) {
		var header = document.getElementById("header");

		if(header.classList.contains("scrolling") == false) {
			header.classList.add("scrolling");
		}
	} else {
		var header = document.getElementById("header");

		if(header.classList.contains("scrolling") == true) {
			header.classList.remove("scrolling");
		}
	}
}

function navOpen(item) {
	closeNavs();
	
	item.classList.add('active');
	item.ariaHidden = "false";
	item.classList.add('fade-in');
}

function navClose(item) {
	item.classList.remove('fade-in');
	item.classList.add('fade-out');
	setTimeout(function() {
		item.ariaHidden = "true";
		item.classList.remove('fade-out');
		item.classList.remove('active');
	}, 100);
}

function closeNavs() {
	var nav = document.getElementById("header");
	var activeNav = nav.querySelectorAll(".subnav.active");

	activeNav.forEach(function(element) {
		var item = element;

		item.classList.remove('fade-in');
		item.classList.add('fade-out');
		setTimeout(function() {
			item.ariaHidden = "true";
			item.classList.remove('fade-out');
			item.classList.remove('active');
		}, 100);
	});
}

function openProductMenu() {
	var productMenuArrow = document.getElementsByClassName("product-arrow");
	var i;
	var subMenu = document.getElementById("product-submenu");

	if (window.location.href.indexOf("features") > -1) {
		subMenu.style.display = "block";
	}
	
	for (i = 0; i < productMenuArrow.length; i++) {
	  productMenuArrow[i].addEventListener("click", function() {
		this.classList.toggle("active");
		if (subMenu.style.display === "block") {
		  subMenu.style.display = "none";
		} else {
		  subMenu.style.display = "block";
		}
	  });
	}
}

function createCookie(name, value, days) {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		expires = "; expires="+date.toGMTString();
	}
	document.cookie = name + "=" + value + expires + "; path=/";
}

function readCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for (var i=0; i<ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) === ' ') {
			c = c.substring(1, c.length);
		}
		if (c.indexOf(nameEQ) === 0) {
			return c.substring(nameEQ.length, c.length);
		}
	}
	return null;
}

function headerNavInit() {
	var nav = document.getElementById("header");
	var mobileNavToggle = document.getElementById("menu-toggle");
	var menu = document.getElementById("menu");
	var openButtonContent = document.getElementsByClassName("header--mobile-open");
	openButtonContent = openButtonContent[0];
	var closeButtonContent = document.getElementsByClassName("header--mobile-close");
	closeButtonContent = closeButtonContent[0];

	mobileNavToggle.addEventListener("click", function() {
		if(window.innerWidth < 1024) {
			var item = this;

			if(menu.classList.contains('active') == true) {
				navClose(menu);
				document.body.style.overflow = "unset";
				closeButtonContent.style.display = "none";
				openButtonContent.style.display = "flex";

				nav.classList.remove('opened-nav');
			} else {
				navOpen(menu);
				document.body.style.overflow = "hidden";
				openButtonContent.style.display = "none";
				closeButtonContent.style.display = "flex";

				nav.classList.add('opened-nav');
			}
		}
	});

	//subnav
	var headerNav = nav.querySelectorAll(".menu-item a");
	var subNavs = nav.querySelectorAll(".subnav");
	var subNavsOpen = nav.querySelectorAll(".subnav--mobile-open");
	var subNavsClose = nav.querySelectorAll(".subnav--mobile-close");
	var closeDelay = '';

	if(headerNav.length > 0) {
		document.onkeydown = function(evt) {
			evt = evt || window.event;
			if (evt.key === "Escape" || evt.key === "Esc") {
				if(nav.querySelectorAll(".subnav.active").length > 0) {
					closeNavs();
				}
			}
		};
	}

	headerNav.forEach(function(element) {
		var item = element;
		var itemWrapper = item.parentNode;

		if(itemWrapper.dataset.subnav != undefined) {
			element.addEventListener("mouseover", function() {
				if(window.innerWidth > 1023) {
					var el = this;
					var wrapper = el.parentNode;

					var dataSubNav = wrapper.dataset.subnav;
					var subNav = document.getElementById(dataSubNav);

					if(closeDelay != '') {
			            clearTimeout(closeDelay);
			            closeDelay = '';
			        }

					if(subNav.classList.contains('active') != true) {
						navOpen(subNav);
					}
				}
			});
			element.addEventListener("mouseout", function() {
				if(window.innerWidth > 1023) {
					var el = this;
					var wrapper = el.parentNode;

					var dataSubNav = wrapper.dataset.subnav;
					var subNav = document.getElementById(dataSubNav);

					if(subNav.classList.contains('active') == true) {
						closeDelay = setTimeout(function() {
							navClose(subNav);
					    }, 200);
					}
				}
			});
		}
	});

	subNavs.forEach(function(element) {
		element.addEventListener("mouseover", function() {
			if(window.innerWidth > 1023) {
				var item = this;

				if(item.classList.contains('active') != true) {
					navOpen(item);
				} else {
					if(closeDelay != '') {
			            clearTimeout(closeDelay);
			            closeDelay = '';
			        }
				}
			}
		});
		element.addEventListener("mouseout", function() {
			if(window.innerWidth > 1023) {
				var item = this;

				if(item.classList.contains('active') == true) {
					closeDelay = setTimeout(function() {
						navClose(item);
				    }, 200);
				}
			}
		});
	});

	subNavsOpen.forEach(function(element) {
		element.addEventListener("click", function() {
			var item = this;
			var dataSubNav = item.dataset.subnav;

			var subNav = document.getElementById(dataSubNav);

			if(subNav.classList.contains('active') != true) {
				navOpen(subNav);
			} else {
				navClose(subNav);
			}
		});
	});

	subNavsClose.forEach(function(element) {
		element.addEventListener("click", function() {
			if(window.innerWidth < 1024) {
				var item = this;
				var dataSubNav = item.dataset.subnav;

				var subNav = document.getElementById(dataSubNav);

				if(subNav.classList.contains('active') == true) {
					navClose(subNav);
				}
			}
		});
	});

	window.addEventListener("resize", function() {
		if(window.innerWidth < 1024) {
			subNavs.forEach(function(element) {
				var item = this;

				if(item.classList.contains('active') == true) {
					item.classList.remove('fade-in');
					item.classList.remove('fade-out');
					item.ariaHidden = "true";
					item.classList.remove('active');
				}
			});
		} else {
			if(window.innerWidth > 1024) {
				if(menu.classList.contains('active') == true) {
					document.body.style.overflow = "unset";
					menu.classList.remove('fade-in');
					menu.classList.remove('fade-out');
					menu.classList.remove('active');
					closeButtonContent.style.display = "none";
					openButtonContent.style.display = "flex";
				}
			}
		}
	});
}

function noticeBannerInit() {
	var banner = document.getElementById("noticeBanner");

	document.getElementById('close-notice-banner').addEventListener('click', function(e) {
		e.preventDefault();

		createCookie('global-banner-hide', true, 7);
		if(document.getElementsByClassName('notice-banner-active').length) {
			document.getElementsByClassName('notice-banner-active')[0].classList.remove('notice-banner-active');
		}
		banner.style.display = "none";
	});
}

//Locations template sliders
var jQuery = require("jquery");
require("@accessible360/accessible-slick");

document.addEventListener( 'DOMContentLoaded', function() {
	var locationTestimonials = document.getElementsByClassName('location-testimonials');
	if (locationTestimonials.length > 0) {
		jQuery('.location-testimonial-slider--wrapper').slick({
			arrows: true,
			autoplay: false,
			dots: true,
			infinite: true,
			adaptiveHeight: true,
			slidesToShow: 1,
  			slidesToScroll: 1,
			responsive: [
			{
				breakpoint: 768,
				settings: {
					arrows: false
				}
			}
			]
		});
	}
});

document.addEventListener( 'DOMContentLoaded', function() {
	var locationPartners = document.getElementsByClassName('location-partners');
	if (locationPartners.length > 0) {
		jQuery('.location-partners-slider--wrapper').slick({
			arrows: true,
			dots: true,
			infinite: true,
			adaptiveHeight: false,
			slidesToShow: 8,
  			slidesToScroll: 1,
			responsive: [
			{
				breakpoint: 1024,
				settings: {
					arrows: true,
					slidesToShow: 4,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 768,
				settings: {
					arrows: false,
					slidesToShow: 2,
					slidesToScroll: 1
				}
			}
			]
		});
	}
});

document.addEventListener( 'DOMContentLoaded', function() {
	jQuery('.testimonial-slider--wrapper').slick({
		dots: true,
		infinite: false,
		adaptiveHeight: true,
	});
});

function openLocationMenu() {
	var locationMenuArrow = document.getElementsByClassName("location-arrow");
	var i;
	var subMenu = document.getElementById("location-submenu");

	if (window.location.href.indexOf("features") > -1) {
		subMenu.style.display = "block";
	}
	
	for (i = 0; i < locationMenuArrow.length; i++) {
		locationMenuArrow[i].addEventListener("click", function() {
		this.classList.toggle("active");
		if (subMenu.style.display === "block") {
		  subMenu.style.display = "none";
		} else {
		  subMenu.style.display = "block";
		}
	  });
	}
}

function hideFeaturedBlogs() {
	var featuredCards = document.querySelector('.resources-grid--featured-cards');
	var cardGrid = document.querySelector('.resources-grid--cards');
	if (featuredCards !== null) {
		document.addEventListener('facetwp-refresh', function() {
			var facets = FWP.facets;
			var isFacetActive = false;
			for (const key in facets) {
				var facet = facets[key];
				if(Array.isArray(facet)) {
					if(facet.length > 0) {
						isFacetActive = true;
					}
				} else {
					if(facet != '') {
						isFacetActive = true;
					}
				}
			}

			document.addEventListener('facetwp-loaded', function() {
				if(isFacetActive == true) {
					if(featuredCards.classList.contains('active') == true) {
						featuredCards.classList.remove('active');
					}
				} else {
					featuredCards.classList.add('active');
				}
			});
		});
	}
}

// initial function (place anything that should begin on page load here)
function init() {
	window.addEventListener("scroll", headerScrolling);
	headerNavInit();
	
	if(document.getElementById("noticeBanner")) {
		noticeBannerInit();
	}

	if(document.getElementById("product-aside")) {
		openProductMenu();
	}

	if(document.getElementById("location-aside")) {
		openLocationMenu();
	}

	if(document.getElementsByClassName("page-template-page-resource")) {
		hideFeaturedBlogs();
	}
}

document.addEventListener("DOMContentLoaded", function() {
	init();
}, false);